import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { variables } from 'components/Theme';
import { WithStyles } from 'decorators/withStyles';
import type { SyntheticEvent } from 'react';
import React, { Component } from 'react';

interface IProps {
  classes?: any;

  hasActive: boolean;
  closeModal?: Function;

  title?: string;
  subTitle?: string | JSX.Element;

  hasButtons?: boolean;
  hideButtonOk?: boolean;

  handleClickOk?: Function;
  textButtonOk?: string;
  textButtonCancel?: string;

  loading?: boolean;

  children: any;
  style?: any;
}

interface IStates {}

@WithStyles({
  modalContent: {
    background: 'white',
    width: 650,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 4,
    maxHeight: '95vh',
    overflow: 'auto',
    maxWidth: '90%',
    padding: 24,
  },
  modalTitle: {
    width: '100%',
    display: 'block',
    fontSize: 20,
    fontWeight: 500,
    color: variables.palette.primary.main,
  },
  modalSubTitle: {
    width: '100%',
    display: 'block',
    fontSize: 16,
    color: variables.palette.primary.light,
  },
  modalBody: {
    width: '100%',
    maxHeight: 'calc(100vh - 240px)',
    overflowX: 'hidden',
  },
  modalButtons: {
    width: '100%',
    display: 'block',
    textAlign: 'right',

    '& button': {
      margin: '0 8px',

      '&:last-child': {
        marginRight: 0,
      },
    },
  },
})
export default class MyModal extends Component<IProps, IStates> {
  onClose = (ev: SyntheticEvent) => {
    if (!this.props.loading) return;
    this.props.closeModal(ev);
  };

  render() {
    const { hasActive, closeModal, title, subTitle, children, hasButtons, hideButtonOk, handleClickOk, textButtonOk, textButtonCancel, loading } =
      this.props;

    if (!hasActive) {
      return null;
    }

    return (
      <Dialog aria-labelledby='modal-orbita-title' aria-describedby='modal-orbita-descripition' open onClose={this.onClose} disableRestoreFocus>
        {title && (
          <DialogTitle>
            {title}
            {subTitle && <DialogContentText>{subTitle}</DialogContentText>}
          </DialogTitle>
        )}

        <DialogContent>{children}</DialogContent>

        {hasButtons && (
          <DialogActions>
            <Button onClick={closeModal as any} color='default' disabled={loading}>
              {textButtonCancel ? textButtonCancel : 'Cancelar'}
            </Button>

            {!hideButtonOk && (
              <Button onClick={handleClickOk as any} variant='contained' color='primary' disabled={loading}>
                {textButtonOk ? textButtonOk : 'Confirmar'}
                {loading && (
                  <span style={{ marginLeft: 10, position: 'relative', top: 2 }}>
                    <CircularProgress size={16} />
                  </span>
                )}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
